import { Link } from '@jsonjoy.com/fs-core';
import { constants, TEncodingExtended, strToEncoding, TDataOut } from '@jsonjoy.com/fs-node-utils';
import type { IDirent } from '@jsonjoy.com/fs-node-utils/lib/types/misc';

const { S_IFMT, S_IFDIR, S_IFREG, S_IFBLK, S_IFCHR, S_IFLNK, S_IFIFO, S_IFSOCK } = constants;

/**
 * A directory entry, like `fs.Dirent`.
 */
export class Dirent implements IDirent {
  static build(link: Link, encoding: TEncodingExtended | undefined) {
    const dirent = new Dirent();
    const { mode } = link.getNode();
    dirent.name = strToEncoding(link.getName(), encoding);
    dirent.mode = mode;
    dirent.parentPath = link.getParentPath();
    dirent.path = dirent.parentPath;
    return dirent;
  }

  name: TDataOut = '';
  parentPath = '';
  private mode: number = 0;

  /**
   * @deprecated Will be removed at any time.
   * @see https://nodejs.org/api/deprecations.html#DEP0178
   */
  path: string = '';

  private _checkModeProperty(property: number): boolean {
    return (this.mode & S_IFMT) === property;
  }

  isDirectory(): boolean {
    return this._checkModeProperty(S_IFDIR);
  }

  isFile(): boolean {
    return this._checkModeProperty(S_IFREG);
  }

  isBlockDevice(): boolean {
    return this._checkModeProperty(S_IFBLK);
  }

  isCharacterDevice(): boolean {
    return this._checkModeProperty(S_IFCHR);
  }

  isSymbolicLink(): boolean {
    return this._checkModeProperty(S_IFLNK);
  }

  isFIFO(): boolean {
    return this._checkModeProperty(S_IFIFO);
  }

  isSocket(): boolean {
    return this._checkModeProperty(S_IFSOCK);
  }
}

export default Dirent;
